import { createContext } from "react";
import { CurrencyContextType } from "./interfaces";

export const CurrencyContext = createContext<CurrencyContextType>({
    rates: [],
    isLoading: true,
    error: null,
    exchangeRates: {},
    lastUpdated: null,
    refreshRates: async () => { },
});